var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',[_c('div',[_c('a-page-header',{staticStyle:{"border":"1px solid rgb(235, 237, 240)"},attrs:{"title":"模板"},on:{"back":_vm.handleGoBack}}),_c('a-row',[_c('a-col',{attrs:{"span":"8"}})],1),_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }